let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1qduh")).then(() => parcelRequire('cu1Rj'));